import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as layoutActions from "../actions/layoutActions";
import { prependRoot } from "../util/prependRoot.js";
import { getApiRoot } from "../store/configureStore.js";
import axios from "axios";
import { showToastrSuccess, showToastrError } from "../util/toastr.js";

import RelativeLink from "./common/RelativeLink";
import Section from "./common/Section";
import Fieldset from "./common/Fieldset";
import Row from "./common/Row";
import Col from "./common/Col";
import Button from "./common/Button";
import TextInput from "./common/TextInput";
import * as types from "../constants/ComponentConstants";
import FriendlyCaptcha from "./common/FriendlyCaptcha";

class TestPage extends Component {
    constructor(props, context) {
        super(props, context, true);

        this.state = {
            federatieId: null,
			buttonDisabled: true
        };
    }

    componentDidMount() {
        this.props.loadLayout();
    }

    nukeCache() {
        const listByUrl = prependRoot("/global/nukecache", getApiRoot());
        axios.get(listByUrl, {
            headers: {
                'accept': 'application/json'
            }
        }).then(response => {
            if (response.statusText === "OK") {
                showToastrSuccess("Cache Cleared");
            } else {
                showToastrError("FAILED. OH NO... :(");
            }
        });
    }

    onChange = (event) => {
        const property = event.target.name;
        const value = event.target.value;

        let newState = Object.assign({}, this.state);
        newState[property] = value;

        this.setState(
            newState
        );
    };

	onVerified = (result) => {
		let newState = Object.assign({}, this.state);
		newState["buttonDisabled"] = !result;

		this.setState(
			newState
		);
	};

	onButtonClick = () => {};

    render() {

        const federatieId = this.state.federatieId;
        const onChange = this.onChange;
        const divStyle = { background: "#f6f6f6", borderRadius: "5px", margin: "10px" };

        return (
            <Section title={"CRMFormulieren - test page"} color={types.COLOR_BLUE}>
                <Row>
                    <Col>
                        <Fieldset>
                            <TextInput
                                name={"federatieId"}
                                label={"Federatie Id"}
                                value={federatieId}
                                onChange={onChange}
                                size={12}
                            />
                        </Fieldset>
                    </Col>
                    <Col>
                        <Fieldset>
                            <Button
                                text={"Clear Cache"}
                                onClick={this.nukeCache}>
                            </Button>
                        </Fieldset>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <div style={divStyle}>
                            <Fieldset title="demo">
                                <RelativeLink to={"/demo"} title="Demo" className="c-button c-button--small">
                                    Demo
                                </RelativeLink>
                                <br />
                                <br />
                                <RelativeLink to={"/externeKlachten"} title="ExterneKlachten" className="c-button c-button--small">
                                    Externe Klachten
                                </RelativeLink>
                                <br />
                                <br />
                                <RelativeLink to={"/interneKlachten"} title="InterneKlachten" className="c-button c-button--small">
                                    Interne Klachten
                                </RelativeLink>
								<br />
								<br />
								<RelativeLink to={"/meldingen"} title="Meldingen" className="c-button c-button--small">
									Meldingen
								</RelativeLink>
                                <br />
                                <br />
                                <RelativeLink to={"/sportenOpHetWerk"} title="SportenOpHetWerk" className="c-button c-button--small">
                                    Sporten op het werk
                                </RelativeLink>
                            </Fieldset>
                        </div>
                    </Col>
                </Row>
				<Row>
					<Col>
						<div style={divStyle}>
							<FriendlyCaptcha onVerified={this.onVerified} />
							<Button onClick={this.onButtonClick} text="Test" disabled={this.state.buttonDisabled} />
						</div>
					</Col>
				</Row>
            </Section >);
    }
}

TestPage.propTypes = {
    loadLayout: PropTypes.func
};

function mapStateToProps(state, ownProps) {
    return {
        //get ref data
    };
}

function mapDispatchToProps(dispatch, ownProps) {
    return {
        loadLayout: bindActionCreators(layoutActions.loadTestPageLayout, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(TestPage);
